export enum RouteName {
    LIVE_CHAT = 'live-chat',
    HOME = 'home',
    GAMES = 'games',
    LIVE_CASINO = 'live-casino',
    GAMEPLAY = 'gameplay',
    SEARCH = 'search',
    WALLET = 'wallet',
    TRANSACTION_HISTORY = 'history',
    MESSAGES = 'messages',
    TNC = 'tnc',
    BONUS_TERMS = 'bonus-terms',
    PRIVACY_AND_COOKIE_POLICY = 'privacy-and-cookie-policy',
    ABOUT_US = 'about-us',
    RESPONSIBLE_GAMING_PAGE = 'responsible-gaming-page',
    COOKIES = 'cookies',
    FAQ = 'faq',
    OFFER = 'offer',
    PAGE404 = '404',
    ACCOUNT = 'account',
    ACCOUNT_LINKING = 'account-linking',
    PROFILE = 'profile',
    CHANGE_EMAIL = 'change-email',
    CHANGE_PASSWORD = 'change-password',
    CHANGE_SECURITY_QUESTION = 'change-security-question',
    MARKETING_PREFERENCES = 'marketing-preferences',
    VERIFICATION = 'verification',
    ACCOUNT_CLOSURE = 'account-closure',
    ACCOUNT_CLOSURE_PROMPT = 'account-closure-prompt',
    ACCOUNT_CLOSURE_FORM = 'account-closure-form',
    ACCOUNT_CLOSURE_ERROR = 'account-closure-error',
    ACCOUNT_CLOSURE_SUCCESS = 'account-closure-success',
    ACCOUNT_CUSTOM_ITEM = 'account-custom-item',
    RESPONSIBLE_GAMING = 'responsible-gaming',
    VIEW_LIMITS = 'view-limits',
    SET_LIMITS = 'set-limits',
    SET_DEPOSIT_LIMITS = 'set-deposit-limits',
    SET_BETTING_LIMITS = 'set-betting-limits',
    REALITY_CHECK = 'reality-check',
    CREATE_LIMITS = 'create-limits',
    SELF_EXCLUDE = 'self-exclude',
    PANIC_SELF_EXCLUDE = 'panic-self-exclude',
    TIME_OUT = 'time-out',
    SOW = 'sow',
    LOGIN = 'login',
    LOGIN_PNP = 'login-pnp',
    SIGN_UP = 'sign-up',
    SIGN_UP_BANKID = 'sign-up-bankid',
    SIGN_UP_REGILY = 'sign-up-regily',
    PASSWORD_RESET = 'password-reset',
    PASSWORD_RESET_EMAIL = 'password-reset-email',
    PASSWORD_RESET_SMS = 'password-reset-sms',
    PASSWORD_RESET_QUESTION = 'password-reset-question',
    PASSWORD_RESET_CONFIRMATION = 'password-reset-confirmation',
    PASSWORD_RESET_SUCCESS = 'password-reset-success',
    PASSWORD_RESET_FORM = 'password-reset-form',
    LOGOUT = 'logout',
    IMPERSONATE = 'impersonate',
    FAQ_CATEGORIES = 'faq-categories',
    FAQ_ENTRIES = 'faq-entries',
    FAQ_SEARCH = 'faq-search',
    REWARDS = 'rewards',
    PROMOTIONS = 'promotions',
    PROMOTION = 'promotion',
    PROGRESS_INFO = 'progress-info',
    REWARD = 'reward',
    USER_INFO = 'user-info',
    RG_QUESTIONNAIRE = 'rg-questionnaire',
    SPORTSBOOK = 'sportsbook',
    LEADERBOARDS = 'leaderboards',
    TOURNAMENTS = 'tournaments',
    TOURNAMENTS_STARTING_SOON = 'tournaments-starting-soon',
    TOURNAMENTS_HISTORY = 'tournaments-history',
    TOURNAMENTS_INFO = 'tournaments-info',
    LANDING = 'landing',
    LANDING_SIGNUP = 'landing-signup',
    SHOP = 'shop',
    TWO_FACTOR_AUTHENTICATION = 'two-factor-authentication',
    SIGN_UP_HYBRID = 'sign-up-hybrid',
    BANK_ID_REDIRECT = 'bank-id-redirect',
    PLAY_CONTROL = 'play-control',
    USER_VERIFICATION = 'unverified-user',
    PENDING_VERIFICATION = 'pending-verification',
    IDENTITY_VERIFICATION = 'identity-verification',
    LOTBA_OLD_SELF_EXCLUSION_LINK = 'external-self-exclusion-lotba',
    BINGO_LOBBY = 'bingo-lobby',
    FREE_TO_PLAY = 'free-to-play',
    PROMOTION_PLAY = 'promotion-play',
    IDENTITY_VERIFICATION_COMPLETE = 'identity-verification-complete',
    LOYALTY_PROGRAM = 'loyalty-program',
}
